// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"132":"875b6945","511":"d10583e6","632":"3769e352"}[chunkId] + ".css";
};